/**
 * Map friendly CSS classes added in Gutenberg to AOS data-* attributes.
 *
 * Usage in block's "Additional CSS class(es)":
 *   aos-fade-up
 *   aos-zoom-in
 *   aos-delay-200
 *   aos-duration-800
 *   aos-offset-120
 *   aos-easing-ease-in-sine     (use hyphens; we'll convert to the exact AOS value)
 *   aos-anchor-#my-section      (CSS selector for anchor)
 *   aos-anchor-placement-top-bottom
 *   aos-mirror-true             (booleans: true/false)
 *   aos-once-true
 */
(function () {
	function applyAOSFromClasses(scope = document) {
		const nodes = scope.querySelectorAll('[class*="aos-"]');

		nodes.forEach((el) => {
			el.classList.forEach((cls) => {
				if (!cls.startsWith("aos-")) return;

				// effect: aos-fade-up → data-aos="fade-up"
				if (
					/^aos-(fade|fade-up|fade-down|fade-left|fade-right|fade-up-right|fade-up-left|fade-down-right|fade-down-left|flip-left|flip-right|flip-up|flip-down|zoom-in|zoom-in-up|zoom-in-down|zoom-in-left|zoom-in-right|zoom-out|zoom-out-up|zoom-out-down|zoom-out-left|zoom-out-right)$/i.test(
						cls
					)
				) {
					el.setAttribute("data-aos", cls.replace(/^aos-/, ""));
					return;
				}

				// Numeric options: delay/duration/offset → data-aos-*
				const numMatch = cls.match(
					/^aos-(delay|duration|offset)-(\d+)$/i
				);
				if (numMatch) {
					el.setAttribute(
						`data-aos-${numMatch[1].toLowerCase()}`,
						numMatch[2]
					);
					return;
				}

				// Easing: aos-easing-ease-in-sine → data-aos-easing="ease-in-sine"
				const easingMatch = cls.match(/^aos-easing-(.+)$/i);
				if (easingMatch) {
					el.setAttribute("data-aos-easing", easingMatch[1]);
					return;
				}

				// Anchor: aos-anchor-#id or .class → data-aos-anchor
				const anchorMatch = cls.match(/^aos-anchor-(.+)$/i);
				if (anchorMatch) {
					el.setAttribute("data-aos-anchor", anchorMatch[1]);
					return;
				}

				// Anchor placement: aos-anchor-placement-top-bottom
				const apMatch = cls.match(/^aos-anchor-placement-(.+)$/i);
				if (apMatch) {
					el.setAttribute("data-aos-anchor-placement", apMatch[1]);
					return;
				}

				// Booleans: aos-once-true / aos-mirror-false
				const boolMatch = cls.match(
					/^aos-(once|mirror)-(true|false)$/i
				);
				if (boolMatch) {
					el.setAttribute(
						`data-aos-${boolMatch[1].toLowerCase()}`,
						boolMatch[2]
					);
					return;
				}
			});
		});
	}

	// Initial pass
	applyAOSFromClasses(document);

	// Init AOS
	window.addEventListener("load", () => {
		AOS.init({
			duration: 500,
			once: true,
			offset: 200,
		});

		// Nudge Safari to compute .aos-init before toggling .aos-animate
		requestAnimationFrame(() => {
			const inView = document.querySelectorAll(".aos-init.aos-animate");
			inView.forEach((el) => {
				el.classList.remove("aos-animate");
				// force reflow
				void el.offsetWidth;
				el.classList.add("aos-animate");
			});

			requestAnimationFrame(() => AOS.refresh());
		});
	});

	// After AOS.init(...)
	function markAOSComplete() {
		document.querySelectorAll("[data-aos]").forEach((el) => {
			// Skip if already marked
			if (el.dataset.aosCompleteBound) return;
			el.dataset.aosCompleteBound = true;

			// Watch for aos-animate being added
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((m) => {
					if (
						m.type === "attributes" &&
						m.attributeName === "class" &&
						el.classList.contains("aos-animate") &&
						!el.classList.contains("aos-complete")
					) {
						// Get delay + duration (fall back to defaults)
						const delay = parseInt(
							el.getAttribute("data-aos-delay") || 0,
							10
						);
						const duration = parseInt(
							el.getAttribute("data-aos-duration") || 400,
							10
						);

						setTimeout(() => {
							el.classList.add("aos-complete");
						}, delay + duration);
					}
				});
			});

			observer.observe(el, {
				attributes: true,
				attributeFilter: ["class"],
			});
		});
	}

	document.addEventListener("DOMContentLoaded", () => {
		markAOSComplete();
	});

	// Observe DOM changes (for AJAXed content, popups, etc.)
	const mo = new MutationObserver((mutations) => {
		let needsRefresh = false;
		mutations.forEach((m) => {
			m.addedNodes.forEach((n) => {
				if (n.nodeType === 1) {
					applyAOSFromClasses(n);
					needsRefresh = true;
				}
			});
		});
		if (needsRefresh && window.AOS && AOS.refreshHard) AOS.refreshHard();
	});

	mo.observe(document.documentElement, { childList: true, subtree: true });
})();
